module.exports = __webpack_public_path__ + "f7084a43cb38a61ed0ff67b723a021ed.svg";